import { getAccessToken } from '../utils/session'
import {
  BASE_URL,
  SELF_SERVICE_GENERATE_TOKEN_API,
  SELF_SERVICE_REFRESH_TOKEN_API,
} from '../endpoints/apiEndpoints'

/**
 * Generate the DWH (Data Warehouse) embed token used to authenticate the
 * Self Service iframe. The BE returns the DWH access_token, refresh_token and
 * the base URL of the embedded React app that will be loaded in the iframe.
 *
 * @returns {Promise<{success: boolean, data?: {access_token: string, refresh_token: string, dwhBaseUrl: string}, message?: string, status?: number}>}
 */
export async function generateSelfServiceToken() {
  const token = getAccessToken()
  const res = await fetch(`${BASE_URL}/${SELF_SERVICE_GENERATE_TOKEN_API}`, {
    method: 'GET',
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
      accept: 'application/json',
    },
  })

  const json = await res.json().catch(() => null)

  if (!res.ok) {
    // Surface status so the caller can branch (401 -> refresh, 403 -> forbidden)
    return {
      success: false,
      status: res.status,
      message: json?.message || `Request failed with status: ${res.status}`,
    }
  }

  return json
}

/**
 * Exchange the DWH refresh token for a fresh DWH access token.
 *
 * @param {string} refreshToken - The DWH refresh token (not the app refresh token).
 * @returns {Promise<{success: boolean, data?: {access_token: string}, message?: string, status?: number}>}
 */
export async function generateSelfServiceRefreshToken(refreshToken) {
  const token = getAccessToken()
  const res = await fetch(`${BASE_URL}/${SELF_SERVICE_REFRESH_TOKEN_API}`, {
    method: 'GET',
    headers: {
      Authorization: token,
      dwh_refresh_token: refreshToken,
      'Content-Type': 'application/json',
      accept: 'application/json',
    },
  })

  const json = await res.json().catch(() => null)

  if (!res.ok) {
    return {
      success: false,
      status: res.status,
      message: json?.message || `Request failed with status: ${res.status}`,
    }
  }

  return json
}
